<template>
  <section class="text-gray-700 body-font">
    <div class="container px-5 py-24 mx-auto">
      <div class="flex flex-wrap w-full mb-20">
        <div class="w-full mb-6 lg:w-1/2 lg:mb-0">
          <h2 class="mb-2 text-2xl font-medium text-gray-900 sm:text-3xl title-font">Nasi zaufani klienci</h2>
          <div class="w-20 h-1 bg-blue-500 rounded"></div>
        </div>
        <p class="w-full text-base leading-relaxed lg:w-1/2">
          Dbamy o to, by nasi Klienci zawsze byli obsługiwani na najwyższym poziomie. Indywidualne podejście to coś, co
          wyróżnia nas wśród konkurencji.
        </p>
      </div>
      <VueSlickCarousel
        :autoplay="true"
        :autoplaySpeed="3000"
        :dots="true"
        :slidesToShow="5"
        :initialSlide="5"
        class="items-center"
      >
        <div class="p-4 xl:w-1/5 md:w-1/2" v-for="(client, index) in clients" :key="index">
          <div class="p-6">
            <img class="object-contain object-center w-full mb-6 rounded" :src="client.img" alt="client" />
          </div>
        </div>
      </VueSlickCarousel>
    </div>
  </section>
</template>

<script>
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
export default {
  name: "Clients",
  components: {
    VueSlickCarousel,
  },
  data() {
    return {
      clients: [
        {
          img: `${require('../assets/img/logotypy/allegift-logo.png')}`
        },
        {
          img: `${require('../assets/img/logotypy/brandhand-logo.png')}`,
        },
        {
          img: `${require('../assets/img/logotypy/bukowianka-logo.png')}`,
        },
        {
          img: `${require('../assets/img/logotypy/magdar-logo.png')}`,
        },
        {
          img: `${require('../assets/img/logotypy/kepi-logo.png')}`,
        },
        {
       img: `${require('../assets/img/logotypy/agrobud-logo.png')}`,
        },
        {
          img: `${require('../assets/img/logotypy/allegift-logo.png')}`,
        },
        {
          img: `${require('../assets/img/logotypy/bukowianka-logo.png')}`,
        },
        {
          img: `${require('../assets/img/logotypy/magdar-logo.png')}`,
        },
      ],
      /*  settings: {
        
        dots: true,
        arrows: true,
        infinite: true,
        speed: 500,
        slidesToShow: 5,
        slidesToScroll: 4,
        initialSlide: 0,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
              infinite: true,
              dots: true,
            },
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
              initialSlide: 2,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      },*/
    };
  },
};
</script>
<style scoped></style>;
